import { createEntityAdapter } from "@reduxjs/toolkit"
import { createAppSlice } from "../../app/createAppSlice"

//entity: {  
//     id: sectionIndex,
//     displayTitle: section.title || section.code..display,
//     compositionId: parent FOI,
//     productFamily: ProfileName,
//     initialSection: sectionJson,
//     revisedSection: sectionJson
// 
//     sectionJson = { extension, title, code, author, focus, text, orderedBy, entry, emptyReason, section }
//key uses: all Composition editing

const topSectionsAdapter = createEntityAdapter({
    sortComparer: (b, a) => {
        if (b?.sectionIndex && a?.sectionIndex && b.sectionIndex !== a.sectionIndex) {
            return b.sectionIndex.localeCompare(a.sectionIndex)
        } else {
            return 0
        }
    }
})

const initialState = topSectionsAdapter.getInitialState({
    status: 'idle'
})

const topSectionsSlice = createAppSlice({
    name: "topSections",
    initialState,
    reducers: create => ({
        topSectionAdded: create.preparedReducer(
            (sectionBody) => {
                return {
                    payload: {
                        id: sectionBody.id,
                        displayTitle: sectionBody.displayTitle,
                        compositionId: sectionBody.compositionId,
                        productFamily: sectionBody.productFamily,
                        initialSection: sectionBody.initialSection,
                        revisedSection: sectionBody.revisedSection
                    }
                };
            },
            topSectionsAdapter.addOne
        ),
        topSectionUpdated: create.reducer((state, action) => {
            const { id, displayTitle, compositionId, productFamily, initialSection, revisedSection } = action.payload;
            topSectionsAdapter.updateOne(state,
                {
                    id, changes: {
                        displayTitle, compositionId, productFamily, initialSection, revisedSection
                           }
                })
        }),
        loadTopSections: create.reducer((state, action) => {
            topSectionsAdapter.setAll(state, action.payload.topSections);
            state.status = "succeeded";
        })
    }),
    selectors: {
        selectTopSectionsStatus: topSections => topSections.status
    }
})

export const { topSectionAdded, topSectionUpdated, loadTopSections } = topSectionsSlice.actions

export const { selectTopSectionsStatus } = topSectionsSlice.selectors

export const {
    selectAll: selectAllTopSections,
    selectById: selectTopSectionById,
} = topSectionsAdapter.getSelectors(state => state.topSections)

export default topSectionsSlice